import styled from 'styled-components';
import { Level3Section } from '../Level3Section';
import { AllPhotosSection } from '../AllPhotosSection';
import { useField } from 'react-final-form';
import { Level1Section, Level2Section } from '../Level1Section';
import { DamageSection } from '../DamageSection';
import { useGetVehicleByIdQuery } from 'services/api/upload-vehicle';
import { useParams } from 'react-router-dom';
import { InspectorComments } from '../InspectorComments';
import { DisclaimerCheckboxes } from '../Disclaimer';
import { isNotesAlwaysOpened } from '../utils';

const Wrapper = styled.div`
  background: #e9edf7;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
`;

type Props = { sectionId: string };

export const SubSectionsList = ({ sectionId }: Props) => {
  const {
    input: { value }
  } = useField(sectionId);

  const { id: vehicleId } = useParams<{ id: string }>();
  const { data: vehicle } = useGetVehicleByIdQuery(Number(vehicleId));

  const isManual = vehicle?.transmission?.toLowerCase().startsWith('manual');

  const is4WD = vehicle?.drive_train?.toLowerCase() === '4wd';

  const sectionKeys = Object.keys(value.subsections);
  const showAllPhotosSection = !['exterior', 'drive_cycles'].includes(sectionId);
  const renderDamagedSection = ['exterior'].includes(sectionId);

  const background = sectionId !== 'exterior' && sectionId?.includes('exterior') ? '#D7E7F3' : '#e9edf7';

  return (
    <Wrapper style={{ background }}>
      {showAllPhotosSection && <AllPhotosSection theme="white" sectionId={sectionId} />}
      {sectionKeys.map((subSectionId, index) => {
        if (subSectionId === 'damaged') {
          return null;
        }
        if (Object.keys(value.subsections?.[subSectionId]?.subsections || {})?.length > 0) {
          return <Level2Section key={subSectionId} sectionId={`${sectionId}.subsections.${subSectionId}`} />;
        }

        if (
          !isManual &&
          sectionId === 'drive_cycles' &&
          ['position_of_clutch_pedal', 'clutch_engages_in_gear', 'manual_transmission_engages_every_gear'].includes(
            subSectionId
          )
        ) {
          return null;
        }

        if (
          !is4WD &&
          sectionId === 'drive_cycles' &&
          ['engage_in_low_4x4', 'engage_in_high_4x4'].includes(subSectionId)
        ) {
          return null;
        }

        const notesOpened = isNotesAlwaysOpened(subSectionId);

        return (
          <Level3Section
            key={subSectionId}
            index={index}
            forceOpen={notesOpened}
            sectionId={`${sectionId}.subsections.${subSectionId}`}
            theme="white"
          />
        );
      })}
      {renderDamagedSection && <DamageSection sectionId={sectionId} />}
      {sectionId === 'drive_cycles' && <InspectorComments theme="white" />}
      {sectionId === 'drive_cycles' && <DisclaimerCheckboxes theme="white" />}
    </Wrapper>
  );
};
